import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

export const FooterOwned = function FooterOwned() {
	const { t } = useTranslation();

	return (
		<div className="u-mar--bottom--xsml">
			<ReactMarkdown linkTarget={"_blank"} className="u-anchor--nested">
				{t("specific:FOOTER.OWNED", {
					interpolation: { escapeValue: false },
				})}
			</ReactMarkdown>
		</div>
	);
};
